import * as React from "react";

const ScheduledIcon = (props) => (
  <svg
    viewBox="0 0 64 64"
    width={24}
    height={24}
    xmlns="http://www.w3.org/2000/svg"
    stroke-width="3"
    stroke={props.stroke ?? "#000000"}
    fill="none"
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path d="M36.66,54.45H8.84A2.5,2.5,0,0,1,6.35,52V12.12A2.49,2.49,0,0,1,8.84,9.63H48.68a2.49,2.49,0,0,1,2.49,2.49v22.4"></path>
      <line x1="6.35" y1="20.63" x2="51.17" y2="20.63"></line>
      <line x1="16.46" y1="9.63" x2="16.46" y2="4.63"></line>
      <line x1="40.42" y1="9.63" x2="40.42" y2="4.63"></line>
      <circle cx="45.22" cy="45.44" r="12.43"></circle>
      <polyline points="45.22 36.7 45.22 45.82 49.57 49.16"></polyline>
    </g>
  </svg>
);

export default ScheduledIcon;
